import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      marginBottom: 16,
      padding: 20,
      '& .titleHome': {
        color: '#374151',
        fontWeight: 300,
        fontSize: 30,
        opacity: 1,
        marginBottom: 10,
        '& span': {
          fontWeight: 400,
          opacity: 0.8,
          color: props.color2,
        }
      },
      '& .logo': {
        minHeight: 221,
        maxWidth: 700,
        margin: '0 auto',
        backgroundSize: '100%',
        background: `transparent url("${props.logoAuthPath}") no-repeat scroll center center`,
      },
    },

    quickActions: {
      marginTop: 20,
      padding: 14,
      display: 'none',

    },

    quickActionsTitle: {
      marginBottom: 12,
      marginRight: 0,
      fontSize: 14,
      fontWeight: 700,
      color: '#1f2937',
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },

    quickActionsGrid: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 10,
    },

    quickActionBtn: {
      display: 'block',
      minHeight: 48,
      width: '100%',
      textTransform: 'none',
      borderRadius: 10,
      padding: '10px 14px',
      border: '1px solid rgba(0,0,0,0.12)',
      background: '#fff',
      marginBottom: 12,
      '&:last-child': {
        marginBottom: 0,
      },
      '& .MuiButton-label': {
        minHeight: 24,
        gap: 10,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }
    },

    quickActionLeft: {
      gap: 10,
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 0,
      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },

    quickActionIcon: {
      fontSize: 18,
      color: props.color2,
      flexShrink: 0,
      marginRight: 10,
    },

    quickActionArrow: {
      fontSize: 18,
      color: '#6b7280',
      flexShrink: 0,

    },

    '@media (max-width: 600px)': {
      container: {
        marginBottom: 18,
        '& .titleHome': {
          fontSize: 'var(--mobile-title-size)',
          fontWeight: 400,
          lineHeight: 'var(--lh-title)',
          marginBottom: 6,
          color: 'var(--text-strong)!important',
          marginTop: 6,
          '& span': {
            fontWeight: 600,
            opacity: 1,
            marginTop: 6,
            display: 'block',
            fontSize: '24px',
            lineHeight: 'var(--lh-body)',
            color: props.HomeNameMobile,          
          }
        },
      },
      quickActions: {
        display: 'block',
        marginTop: 16,
      },
      quickActionsGrid: {
        display: 'flex',
        flexDirection: 'column',
      },
    }
  }));
  return styles();
}
export default theme;

